import { Action } from '@ngrx/store';

export class AuthorizationAction implements Action {

    public static authorize: string = '[Authorization] autorize';
    public static authorizeEnd: string = '[Authorization] autorize_end';
    public static authorizeError: string = '[Authorization] autorize_error';
    public static authorizeDenied: string = '[Authorization] autorize_denied';
    public static authorizeAborted: string = '[Authorization] autorize_aborted';
    public static authorizeSuccess: string = '[Authorization] autorize_success';
    public static authorizeNewToken: string = '[Authorization] autorize_new_token';

    public static requestTokenTime: string = '[Authorization] request_token';
    public static requestTokenTimeError: string = '[Authorization] request_token_error';
    public static requestTokenTimeSuccess: string = '[Authorization] request_token_success';

    public static requestTokenMonthly: string = '[Authorization] request_token_montlhy';
    public static requestTokenMonthlyError: string = '[Authorization] request_token_montlhy_error';
    public static requestTokenMonthlySuccess: string = '[Authorization] request_token_montlhy_success';

    public static requestChangePhoneToken: string = '[Authorization] request_changephone_token';
    public static requestChangePhoneTokenError: string = '[Authorization] request_changephone_token_error';
    public static requestChangePhoneTokenSucess: string = '[Authorization] request_changephone_token_success';

    public static requestUserByToken: string = '[Authorization] request_user_by_token';
    public static requestUserByTokenError: string = '[Authorization] request_user_by_token_error';
    public static requestUserByTokenSucess: string = '[Authorization] request_user_by_token_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
